import {getScript} from "./general";

document.addEventListener("DOMContentLoaded", () => {
  const YANDEX_CAPTCHA = 'yandex-captcha';
  const form = document.querySelector('[data-vue]');
  if (form && form.getAttribute('data-captcha') === YANDEX_CAPTCHA) {
    getScript('https://smartcaptcha.yandexcloud.net/captcha.js', () => {
      if ('forms' in window) {
        window.forms.forEach((vueForm) => {
          vueForm.initializeCaptcha();
        })
      }
    })
      .catch(() => {
        console.error('Ошибка: Не удалось загрузить скрипт YandexSmartCaptcha.')
      })
  }
});
